import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export function fancyBox() {
  // Default fancybox configuration (no navigation)
  Fancybox.bind("[data-fancybox]:not([data-fancybox='team-members']):not([data-fancybox='demo-modal']):not([data-fancybox='career-modal'])", {
    Carousel: {
      transition: "slide",
      Navigation: false,
    },
    Thumbs: {
      showOnStart: false,
    },
    tpl: {
      closeButton:
      `
      <button data-fancybox-close class="f-button is-close-btn">
        <svg width="37" height="39" viewBox="0 0 37 39" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="35.7071" y1="2.70711" x2="0.707107" y2="37.7071" stroke="black" stroke-width="2"/>
          <line x1="0.707107" y1="1.29289" x2="35.7071" y2="36.2929" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      `
    }
  })

  // Team members fancybox configuration
  // Handle team-member clicks manually to create instance with dragToClose disabled but carousel navigation enabled
  let teamModalInstance = null;

  document.addEventListener('click', function(event) {
    // Only handle links that match team-members with data-fancybox attribute
    const link = event.target.closest('a[data-fancybox="team-members"]');
    if (!link) {
      return; // Not a team-member link, let it proceed normally
    }
    
    // Get the href to determine which modal to show
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) {
      return; // Invalid href
    }
    
    // Prevent the default navigation
    event.preventDefault();
    
    // Collect all team member links to create a carousel
    const allTeamLinks = document.querySelectorAll('a[data-fancybox="team-members"]');
    const slides = Array.from(allTeamLinks).map(teamLink => ({
      src: teamLink.getAttribute('href'),
      type: 'inline'
    }));
    
    // Find the index of the clicked link
    const currentIndex = Array.from(allTeamLinks).indexOf(link);
    
    // Manually trigger Fancybox with configuration
    teamModalInstance = Fancybox.show(slides, {
      startIndex: currentIndex,
      Carousel: {
        transition: "fade",
        infinite: true,
      },
      Thumbs: {
        showOnStart: false,
      },
      Panzoom: {
        friction: 0.1, // Higher friction (default is 0.5, lower = more friction)
        lockAxis: true, // Lock axis to prevent accidental horizontal swipes during vertical scroll
        threshold: 20, // Minimum pixels to move before triggering swipe (default is 10)
      },
      backdrop: "rgba(11, 23, 85, 0.97)",
      // dragToClose: false,
      on: {
        close: (fancybox, slide, trigger) => {
          // Clear the instance reference
          teamModalInstance = null;
        }
      },
      tpl: {
        closeButton:
        `
        <button data-fancybox-close class="">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5137 1.25L1.25022 17.5135" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M1.25 1.25L17.5135 17.5135" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </button>
        `,
      }
    });
  }, false);

  // Demo modal fancybox configuration
  // Note: We handle demo-modal clicks manually to prevent hash navigation issues
  // See the click handler below for the actual implementation

  // Track if we're currently managing a demo-modal instance
  let demoModalInstance = null;

  // Prevent hash navigation for demo-modal links
  // We need to prevent default to stop the browser from setting the hash,
  // but then manually trigger Fancybox since we intercepted the click
  document.addEventListener('click', function(event) {
    // Only handle links that specifically match demo-modal with data-fancybox attribute
    const link = event.target.closest('a[href="#demo-modal"][data-fancybox="demo-modal"]');
    if (!link) {
      return; // Not a demo-modal link, let it proceed normally
    }
    
    // Prevent the default hash navigation
    event.preventDefault();
    // Don't use stopPropagation - let other handlers run if needed
    
    // Manually trigger Fancybox with the same configuration
    demoModalInstance = Fancybox.show([{
      src: '#demo-modal',
      type: 'inline'
    }], {
      Carousel: {
        transition: "fade",
        Navigation: false,
        infinite: false,
      },
      Thumbs: {
        showOnStart: false,
      },
      backdrop: "rgba(11, 23, 85, 0.97)",
      Hash: false,
      on: {
        close: (fancybox, slide, trigger) => {
          // Clear the hash when modal closes to prevent reopening
          setTimeout(() => {
            if (window.location.hash === '#demo-modal') {
              history.replaceState(null, null, window.location.pathname + window.location.search);
            }
            // Clear the instance reference
            demoModalInstance = null;
          }, 0);
        }
      },
      tpl: {
        closeButton:
        `
        <button data-fancybox-close class="">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5137 1.25L1.25022 17.5135" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M1.25 1.25L17.5135 17.5135" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </button>
        `,
      }
    });
  }, false); // Use bubble phase instead of capture to avoid interfering with other handlers

  // Career modal fancybox configuration
  // Similar to demo-modal, we handle career-modal clicks manually to prevent hash navigation issues

  // Track if we're currently managing a career-modal instance
  let careerModalInstance = null;

  // Prevent hash navigation for career-modal links
  document.addEventListener('click', function(event) {
    // Only handle links that specifically match career-modal with data-fancybox attribute
    const link = event.target.closest('a[href="#career-modal"][data-fancybox="career-modal"]');
    if (!link) {
      return; // Not a career-modal link, let it proceed normally
    }
    
    // Prevent the default hash navigation
    event.preventDefault();
    // Don't use stopPropagation - let other handlers run if needed
    
    // Manually trigger Fancybox with the same configuration
    careerModalInstance = Fancybox.show([{
      src: '#career-modal',
      type: 'inline'
    }], {
      Carousel: {
        transition: "fade",
        Navigation: false,
        infinite: false,
      },
      Thumbs: {
        showOnStart: false,
      },
      backdrop: "rgba(11, 23, 85, 0.97)",
      Hash: false,
      on: {
        close: (fancybox, slide, trigger) => {
          // Clear the hash when modal closes to prevent reopening
          setTimeout(() => {
            if (window.location.hash === '#career-modal') {
              history.replaceState(null, null, window.location.pathname + window.location.search);
            }
            // Clear the instance reference
            careerModalInstance = null;
          }, 0);
        }
      },
      tpl: {
        closeButton:
        `
        <button data-fancybox-close class="">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5137 1.25L1.25022 17.5135" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M1.25 1.25L17.5135 17.5135" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </button>
        `,
      }
    });
  }, false); // Use bubble phase instead of capture to avoid interfering with other handlers

  // const nextButtons = document.querySelectorAll('.modal__next button')

  // for (const nextButton of nextButtons) {
  //   nextButton.addEventListener('click', () => {
  //     Fancybox.next()
  //   })
  // }
}